export default __webpack_public_path__ + "static/media/IconDesc_PlutoniumPellet.256.48e2f07c.png";